import { IconCheck } from '@lib/icons'
import cx from 'classnames'
import type React from 'react'

import css from './Rule.module.scss'

type Props = {
  isValid: boolean
  rule: string
}

const Rule: React.FC<Props> = ({ isValid, rule }) => {
  const classes = {
    container: cx(css.container, {
      [css.valid]: isValid,
    }),
  }

  return (
    <div className={classes.container}>
      <div className={css.icon}>
        <IconCheck size={16} />
      </div>

      <div className={css.rule}>{rule}</div>
    </div>
  )
}

export default Rule
